module.exports = __webpack_public_path__ + "images/FUSA_icons/032-invoice.ca0d39abc3b2be9202a3b5ca783ad242.svg";